import Vue, { PluginObject } from 'vue'
import Editor from '@/components/Editor/Editor.vue'
import FormField from '@/components/FormField/FormField.vue'
import STextArea from '@/components/STextArea/STextArea.vue'
import SHint from '@/components/SHint/SHint.vue'
import CounterValue from '@/components/CounterValue/CounterValue.vue'
import SAvatar from '@/components/SAvatar/SAvatar.vue'
import SRadioButton from '@/components/SRadioButton/SRadioButton.vue'

export const AppComponentsPlugin: PluginObject<undefined> = {
  install() {
    const components = {
      Editor,
      SAvatar,
      SRadioButton,
      CounterValue,
      FormField,
      STextArea,
      SHint,
      SectionMultiselect: () =>
        import('@/components/SectionMultiselect/SectionMultiselect.vue'),
      TableFooter: () => import('@/components/TableFooter/TableFooter.vue'),
      DataTable: () => import('@/components/DataTable/DataTable.vue'),
      UrlCodeTextarea: () =>
        import('@/components/UrlCodeTextarea/UrlCodeTextarea.vue'),
      BaseAutocomplete: () =>
        import('@/components/BaseAutocomplete/BaseAutocomplete.vue'),
      FilteredSearchBlock: () =>
        import('@/components/FilteredSearchBlock/FilteredSearchBlock.vue'),
      ImageCrop: () => import('@/components/ImageCrop/ImageCrop.vue'),
      ImageUi: () => import('@/components/ImageUi/ImageUi.vue'),
      CopyTextMenu: () => import('@/components/CopyTextMenu/CopyTextMenu.vue'),
      ImageSourceCombobox: () =>
        import('@/components/ImageSourceCombobox/ImageSourceCombobox.vue'),
      ConfirmDeleteDialog: () =>
        import('@/components/ConfirmDeleteDialog/ConfirmDeleteDialog.vue'),
      ExpandMultiselect: () =>
        import('@/components/ExpandMultiselect/ExpandMultiselect.vue'),
      DraggableImagesPanel: () =>
        import(
          '@/components/DraggableImages/DraggableImagesPanel/DraggableImagesPanel.vue'
        ),
      DraggableImages: () =>
        import('@/components/DraggableImages/DraggableImages.vue'),
      DraggableImagesContainer: () =>
        import(
          '@/components/DraggableImages/DraggableImagesContainer/DraggableImagesContainer.vue'
        ),
      DropZone: () => import('@/components/DropZone/DropZone.vue'),
      ImageUploader: () =>
        import('@/components/ImageUploader/ImageUploader.vue'),
      ImageCropper: () => import('@/components/ImageCropper/ImageCropper.vue'),
      DataTimePicker: () =>
        import('@/components/DataTimePicker/DataTimePicker.vue'),
      AnalyticsReadingNow: () =>
        import('@/components/AnalyticsReadingNow/AnalyticsReadingNow.vue'),
      AnalyticsCompareChart: () =>
        import('@/components/AnalyticsCompareChart/AnalyticsCompareChart.vue'),
      EditorContainer: () =>
        import('@/components/EditorContainer/EditorContainer.vue'),
      ExpandAutocomplete: () =>
        import('@/components/ExpandAutocomplete/ExpandAutocomplete.vue'),
      AllArticleStat: () =>
        import('@/components/AllArticleStat/AllArticleStat.vue'),
      TopArticleStat: () =>
        import('@/components/TopArticleStat/TopArticleStat.vue'),
      StatLayout: () => import('@/components/StatLayout/StatLayout.vue'),
      ContenteditableElement: () =>
        import(
          '@/components/ContenteditableElement/ContenteditableElement.vue'
        ),
      DateTime: () => import('@/components/DateTime/DateTime.vue'),
      VCropper: () => import('@/components/VCropper/VCropper.vue'),
      LogoutAlert: () => import('@/components/LogoutAlert/LogoutAlert.vue'),
      UnknowAlert: () => import('@/components/UnknowAlert/UnknowAlert.vue'),
      DownloadedButton: () =>
        import('@/components/DownloadedButton/DownloadedButton.vue'),
      ArticleImageWidget: () =>
        import('@/components/ArticleImageWidget/ArticleImageWidget.vue'),
      InfiniteScroll: () =>
        import('@/components/InfiniteScroll/InfiniteScroll.vue'),
      MaskInput: () => import('@/components/MaskInput/MaskInput.vue'),
      Topbar: () => import('@/components/Topbar/Topbar.vue'),
      Tooltip: () => import('@/components/Tooltip/Tooltip.vue'),
      BaseCombobox: () => import('@/components/BaseCombobox/BaseCombobox.vue'),
      DatePicker: () => import('@/components/DatePicker/DatePicker.vue'),
      SimpleEditor: () => import('@/components/SimpleEditor/SimpleEditor.vue'),
      ImageSource: () => import('@/components/ImageSource/ImageSource.vue'),
      ConfirmRestoreDialog: () =>
        import('@/components/ConfirmRestoreDialog/ConfirmRestoreDialog.vue'),
    }

    components.ImageUi()
    components.ArticleImageWidget()
    components.ImageCropper()
    components.ImageCrop()
    components.Tooltip()
    components.BaseAutocomplete()
    components.BaseCombobox()
    components.ImageUploader()
    components.DateTime()

    Object.entries(components).forEach(([id, constructor]) => {
      Vue.component(id, constructor)
    })
  },
}
